/**
 * AUTO-GENERATED — do not edit manually.
 * Run: npm run gql:extract-runtime-enums -w=shared
 * Source: common/global-types.d.ts (GraphQL codegen)
 */

/** Enum for the possible statuses */
export enum ActionItemStatusEnumType {
  /** done */
  Done = 'DONE',
  /** not_started */
  NotStarted = 'NOT_STARTED',
  /** working_on_it */
  WorkingOnIt = 'WORKING_ON_IT'
}

/** Enum for the possible ActionItem visibilities */
export enum ActionItemVisibilityEnumType {
  /** hidden */
  Hidden = 'HIDDEN',
  /** visible */
  Visible = 'VISIBLE'
}

/** Enum for the possible Archive projects permissions */
export enum ArchiveProjectsPermissionsEnumType {
  /** admin_only */
  AdminOnly = 'ADMIN_ONLY',
  /** admin_or_pm */
  AdminOrPm = 'ADMIN_OR_PM',
  /** everyone */
  Everyone = 'EVERYONE'
}

/** Enum for the possible assetable types */
export enum AssetableEnumType {
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** milestone */
  Milestone = 'MILESTONE',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** Enum for the possible capacity group by */
export enum CapacityGroupByEnum {
  /** day */
  Day = 'DAY',
  /** week */
  Week = 'WEEK'
}

/** Enum for the possible country code */
export enum CountryCodeEnumType {
  /** de */
  De = 'de',
  /** en */
  En = 'en',
  /** hi */
  Hi = 'hi',
  /** ja */
  Ja = 'ja',
  /** pt */
  Pt = 'pt',
  /** sv */
  Sv = 'sv',
  /** zh */
  Zh = 'zh'
}

/** Enum for the possible currency code */
export enum CurrencyCodeEnumType {
  /** AUD */
  Aud = 'AUD',
  /** BRL */
  Brl = 'BRL',
  /** CAD */
  Cad = 'CAD',
  /** CHF */
  Chf = 'CHF',
  /** EUR */
  Eur = 'EUR',
  /** GBP */
  Gbp = 'GBP',
  /** INR */
  Inr = 'INR',
  /** JPY */
  Jpy = 'JPY',
  /** NZD */
  Nzd = 'NZD',
  /** RMB */
  Rmb = 'RMB',
  /** USD */
  Usd = 'USD'
}

/** Enum for the possible user task contexts */
export enum CurrentUserTaskContextEnumType {
  /** assignee */
  Assignee = 'ASSIGNEE',
  /** participant */
  Participant = 'PARTICIPANT'
}

/** customer dashboard statuses enum type */
export enum CustomerDashboardStatusesEnumType {
  /** done */
  Done = 'DONE',
  /** late */
  Late = 'LATE',
  /** remaining */
  Remaining = 'REMAINING'
}

/** Enum for the possible dependency types */
export enum DependencyEnumType {
  /** milestone */
  Milestone = 'MILESTONE',
  /** task */
  Task = 'TASK',
  /** task_group */
  TaskGroup = 'TASK_GROUP',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the possible dependency */
export enum DependencyStatusEnumType {
  /** complete */
  Complete = 'COMPLETE',
  /** incomplete */
  Incomplete = 'INCOMPLETE',
  /** no_depedency */
  NoDependency = 'NO_DEPENDENCY'
}

/** Enum for the possible importer history status type */
export enum ImporterHistoryStatusType {
  /** creating */
  Creating = 'CREATING',
  /** done */
  Done = 'DONE',
  /** failed */
  Failed = 'FAILED'
}

/** Enum for the possible importer history upload type */
export enum ImporterHistoryUploadType {
  /** project */
  Project = 'PROJECT',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the possible info fields types */
export enum InfoFieldsEnum {
  /** merge_tag */
  MergeTag = 'MERGE_TAG'
}

/** Enum for the possible device types */
export enum InstallationDeviceTypeEnum {
  /** android */
  Android = 'ANDROID',
  /** ios */
  Ios = 'IOS'
}

/** Enum for formatting jira epic names */
export enum JiraEpicFormatEnumType {
  /** postfix */
  Postfix = 'POSTFIX',
  /** prefix */
  Prefix = 'PREFIX',
  /** project_name */
  ProjectName = 'PROJECT_NAME'
}

/** Enum for formatting jira issue names */
export enum JiraIssueFormatEnumType {
  /** brand_prefix */
  BrandPrefix = 'BRAND_PREFIX',
  /** name_only */
  NameOnly = 'NAME_ONLY',
  /** project_prefix */
  ProjectPrefix = 'PROJECT_PREFIX'
}

/** Enum for pushing a GuideCX project as a Jira project or a Jira epic */
export enum JiraPushAsEnumType {
  /** epic */
  Epic = 'EPIC',
  /** project */
  Project = 'PROJECT'
}

/** Enum for the merge taggables */
export enum MergeTaggable {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the merge taggables */
export enum MergeTaggableType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** task */
  Task = 'TASK',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the possible milestones statuses */
export enum MilestoneStatusEnumType {
  /** complete */
  Complete = 'COMPLETE',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** not_started */
  NotStarted = 'NOT_STARTED'
}

/** Enum for the possible note visibility types */
export enum NoteVisibilityEnumType {
  /** internal */
  Internal = 'INTERNAL',
  /** public */
  Public = 'PUBLIC'
}

/** Enum for the possible noteable types */
export enum NoteableEnumType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** Enum for the possible notification types */
export enum NotificationTypeEnumType {
  /** Deprecated notification type. Will be removed Q2 2022 */
  Activity = 'ACTIVITY',
  /** user @mentions */
  Communication = 'COMMUNICATION',
  /** Errors for users to take action to fix */
  Error = 'ERROR',
  /** Notifications targeted at integrations like Slack */
  Integration = 'INTEGRATION',
  /** General web notifications */
  Notification = 'NOTIFICATION',
  /** Automated, system notifications */
  Schedule = 'SCHEDULE'
}

/** Enum for operator */
export enum OperatorEnumType {
  /** and */
  And = 'AND',
  /** or */
  Or = 'OR'
}

/** Enum for the possible organization customer types */
export enum OrganizationCustomerTypeEnumType {
  /** company */
  Company = 'COMPANY',
  /** individual */
  Individual = 'INDIVIDUAL',
  /** internal */
  Internal = 'INTERNAL'
}

export enum OrganizationSortEnum {
  CreatedAt = 'CREATED_AT',
  Domain = 'DOMAIN',
  Name = 'NAME'
}

export enum OrganizationStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Trial = 'TRIAL'
}

/** Enum for the possible organization types */
export enum OrganizationTypeEnumType {
  /** basic */
  Basic = 'BASIC',
  /** provider */
  Provider = 'PROVIDER',
  /** super_admin */
  SuperAdmin = 'SUPER_ADMIN',
  /** third_party */
  ThirdParty = 'THIRD_PARTY'
}

/** Enum for the possible pending project providers */
export enum PendingProjectProviderEnumType {
  /** hubspot */
  Hubspot = 'HUBSPOT',
  /** open_api */
  OpenApi = 'OPEN_API',
  /** salesforce */
  Salesforce = 'SALESFORCE'
}

/** Enum for the possible drag and drop position qualifiers */
export enum PositionQualifierEnum {
  /** after */
  After = 'AFTER',
  /** before */
  Before = 'BEFORE'
}

/** Enum for the possible priority types */
export enum PriorityEnumType {
  /** high */
  High = 'HIGH',
  /** low */
  Low = 'LOW',
  /** medium */
  Medium = 'MEDIUM'
}

/** Enum for the possible project or template type */
export enum ProjectOrTemplateEnumType {
  /** project */
  Project = 'PROJECT',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the project overview email preferences */
export enum ProjectOverviewEmailPrefEnumType {
  /** daily */
  Daily = 'DAILY',
  /** monthly */
  Monthly = 'MONTHLY',
  /** overview_off */
  OverviewOff = 'OVERVIEW_OFF',
  /** weekly */
  Weekly = 'WEEKLY'
}

/** Enum for the possible project status types */
export enum ProjectStatusEnum {
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** done */
  Done = 'DONE',
  /** late */
  Late = 'LATE',
  /** on_hold */
  OnHold = 'ON_HOLD',
  /** on_time */
  OnTime = 'ON_TIME'
}

/** Enum for the possible project types */
export enum ProjectTypeEnumType {
  /** external */
  External = 'EXTERNAL',
  /** internal */
  Internal = 'INTERNAL'
}

/** Enum for the possible project views for customers */
export enum ProjectViewEnum {
  /** compass */
  Compass = 'COMPASS',
  /** legacy */
  Legacy = 'LEGACY'
}

/** Enum for the possible rate types */
export enum RateTypeEnum {
  /** fixed_dollars */
  FixedDollars = 'FIXED_DOLLARS',
  /** fixed_hours */
  FixedHours = 'FIXED_HOURS',
  /** fixed_rate */
  FixedRate = 'FIXED_RATE',
  /** variable_rate */
  VariableRate = 'VARIABLE_RATE'
}

/** Enum for the possible report scope types */
export enum ReportScopeEnumType {
  /** projects */
  Projects = 'PROJECTS',
  /** users */
  Users = 'USERS'
}

/** Enum to filter resource users by type */
export enum ResourceTypeFilterEnum {
  /** all */
  All = 'ALL',
  /** internal */
  Internal = 'INTERNAL',
  /** third_party */
  ThirdParty = 'THIRD_PARTY'
}

/** Supported Salesforce API Hosts */
export enum SalesforceHostEnum {
  Production = 'PRODUCTION',
  Sandbox = 'SANDBOX'
}

/** Enum for all the possible list sorting */
export enum SortByEnumType {
  /** allotted_hours */
  AllottedHours = 'ALLOTTED_HOURS',
  /** assignee_name */
  AssigneeName = 'ASSIGNEE_NAME',
  /** billable_rate */
  BillableRate = 'BILLABLE_RATE',
  /** billable_users_count */
  BillableUsersCount = 'BILLABLE_USERS_COUNT',
  /** brand */
  Brand = 'BRAND',
  /** cash_value */
  CashValue = 'CASH_VALUE',
  /** category_id */
  Category = 'CATEGORY',
  /** category_skills_count */
  CategorySkillsCount = 'CATEGORY_SKILLS_COUNT',
  /** cost_rate */
  CostRate = 'COST_RATE',
  /** created_at */
  Created = 'CREATED',
  /** creator_id */
  Creator = 'CREATOR',
  /** csat */
  Csat = 'CSAT',
  /** customer */
  Customer = 'CUSTOMER',
  /** customer_name */
  CustomerName = 'CUSTOMER_NAME',
  /** date_range */
  DateRange = 'DATE_RANGE',
  /** date_worked */
  DateWorked = 'DATE_WORKED',
  /** dependency */
  Dependency = 'DEPENDENCY',
  /** description */
  Description = 'DESCRIPTION',
  /** dollars */
  Dollars = 'DOLLARS',
  /** due_on */
  DueOn = 'DUE_ON',
  /** due_on_and_dependency */
  DueOnAndDependency = 'DUE_ON_AND_DEPENDENCY',
  /** last_edited_by_id */
  EditedBy = 'EDITED_BY',
  /** end_on */
  EndOn = 'END_ON',
  /** file_name */
  FileName = 'FILE_NAME',
  /** first_name */
  FirstName = 'FIRST_NAME',
  /** hours */
  Hours = 'HOURS',
  /** last_activity_at */
  LastActivityAt = 'LAST_ACTIVITY_AT',
  /** last_name */
  LastName = 'LAST_NAME',
  /** milestone */
  Milestone = 'MILESTONE',
  /** milestone_name */
  MilestoneName = 'MILESTONE_NAME',
  /** my_open_tasks */
  MyOpenTasks = 'MY_OPEN_TASKS',
  /** name */
  Name = 'NAME',
  /** open_action_items */
  OpenActionItems = 'OPEN_ACTION_ITEMS',
  /** open_tasks */
  OpenTasks = 'OPEN_TASKS',
  /** overdue_tasks_count */
  OverdueTasksCount = 'OVERDUE_TASKS_COUNT',
  /** pm_name */
  PmName = 'PM_NAME',
  /** priority */
  Priority = 'PRIORITY',
  /** projected_end_on */
  ProjectedEndOn = 'PROJECTED_END_ON',
  /** project_end */
  ProjectEnd = 'PROJECT_END',
  /** project_name */
  ProjectName = 'PROJECT_NAME',
  /** provider */
  Provider = 'PROVIDER',
  /** published */
  Published = 'PUBLISHED',
  /** rate_type */
  RateType = 'RATE_TYPE',
  /** sign_off */
  SignOff = 'SIGN_OFF',
  /** skills_count */
  SkillsCount = 'SKILLS_COUNT',
  /** start_on */
  StartOn = 'START_ON',
  /** status */
  Status = 'STATUS',
  /** stuck_tasks */
  StuckTasks = 'STUCK_TASKS',
  /** task_name */
  TaskName = 'TASK_NAME',
  /** template_name */
  TemplateName = 'TEMPLATE_NAME',
  /** time_elapsed */
  TimeElapsed = 'TIME_ELAPSED',
  /** billable */
  TimeRecordType = 'TIME_RECORD_TYPE',
  /** org_type */
  Type = 'TYPE',
  /** updated_at */
  Updated = 'UPDATED',
  /** uploader */
  Uploader = 'UPLOADER',
  /** users_count */
  UsersCount = 'USERS_COUNT',
  /** utilized_capacity */
  UtilizedCapacity = 'UTILIZED_CAPACITY',
  /** worker_id */
  Worker = 'WORKER'
}

/** Enum for the possible sort directions */
export enum SortDirectionEnumType {
  /** asc */
  Asc = 'ASC',
  /** desc */
  Desc = 'DESC'
}

/** Enum for the possible sortable elements */
export enum SortableElementEnum {
  /** task */
  Task = 'TASK',
  /** task_group */
  TaskGroup = 'TASK_GROUP'
}

/** Enum for the possible stats types */
export enum StatsEnumType {
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** milestone */
  Milestone = 'MILESTONE',
  /** project */
  Project = 'PROJECT'
}

/** Enum for the possible statuses */
export enum StatusEnumType {
  /** cancelled */
  Cancelled = 'CANCELLED',
  /** done */
  Done = 'DONE',
  /** late */
  Late = 'LATE',
  /** non_responsive */
  NonResponsive = 'NON_RESPONSIVE',
  /** not_applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** unscheduled */
  NotScheduled = 'NOT_SCHEDULED',
  /** not_started */
  NotStarted = 'NOT_STARTED',
  /** on_hold */
  OnHold = 'ON_HOLD',
  /** on_time */
  OnTime = 'ON_TIME',
  /** scheduled */
  Scheduled = 'SCHEDULED',
  /** sign_off */
  SignOff = 'SIGN_OFF',
  /** stuck */
  Stuck = 'STUCK',
  /** working_on_it */
  WorkingOnIt = 'WORKING_ON_IT'
}

/** Enum for the possible status update types */
export enum StatusObjectEnumType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** Enum for the possible taggable types */
export enum TaggableEnumType {
  /** action_item */
  ActionItem = 'ACTION_ITEM',
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** Enum for the possible task groups statuses */
export enum TaskGroupStatusEnumType {
  /** complete */
  Complete = 'COMPLETE',
  /** in_progress */
  InProgress = 'IN_PROGRESS',
  /** not_started */
  NotStarted = 'NOT_STARTED'
}

/** Enum for the project overview email preferences */
export enum TaskReminderEmailPref {
  /** one_day */
  OneDay = 'ONE_DAY',
  /** task_reminder_off */
  TaskReminderOff = 'TASK_REMINDER_OFF',
  /** three_days */
  ThreeDays = 'THREE_DAYS',
  /** two_days */
  TwoDays = 'TWO_DAYS'
}

/** Enum for the possible task responsibility options */
export enum TaskResponsibilityEnumType {
  /** all */
  All = 'ALL',
  /** customer */
  Customer = 'CUSTOMER',
  /** internal */
  Internal = 'INTERNAL',
  /** internal_in_project */
  InternalInProject = 'INTERNAL_IN_PROJECT',
  /** not_in_project */
  NotInProject = 'NOT_IN_PROJECT',
  /** third_party */
  ThirdParty = 'THIRD_PARTY'
}

/** Enum for the possible status for a task */
export enum TaskStatusEnum {
  /** done */
  Done = 'DONE',
  /** not_applicable */
  NotApplicable = 'NOT_APPLICABLE',
  /** unscheduled */
  NotScheduled = 'NOT_SCHEDULED',
  /** not_started */
  NotStarted = 'NOT_STARTED',
  /** scheduled */
  Scheduled = 'SCHEDULED',
  /** sign_off */
  SignOff = 'SIGN_OFF',
  /** stuck */
  Stuck = 'STUCK',
  /** working_on_it */
  WorkingOnIt = 'WORKING_ON_IT'
}

/** Enum for the possible task types */
export enum TaskTypeEnumType {
  /** event */
  Event = 'EVENT',
  /** grouped */
  Group = 'GROUP',
  /** regular */
  Regular = 'REGULAR'
}

/** Enum for the possible task visibilities */
export enum TaskVisibilityEnumType {
  /** hidden */
  Hidden = 'HIDDEN',
  /** name_only */
  NameOnly = 'NAME_ONLY',
  /** visible */
  Visible = 'VISIBLE'
}

/** Enum for the possible template types */
export enum TemplateEnumType {
  /** blueprint_template */
  BlueprintTemplate = 'BLUEPRINT_TEMPLATE',
  /** template */
  Template = 'TEMPLATE'
}

/** Enum for the possible report scope types */
export enum TimeReportExportStyleEnumType {
  /** detailed */
  Detailed = 'DETAILED',
  /** summary */
  Summary = 'SUMMARY'
}

/** Enum for the time report warnings */
export enum TimeReportWarningEnumType {
  /** fixed_rate_cost_incomplete */
  FixedRateCostIncomplete = 'FIXED_RATE_COST_INCOMPLETE'
}

/** Enum for updater */
export enum UpdaterEnumType {
  /** add */
  Add = 'ADD',
  /** replace */
  Replace = 'REPLACE'
}

/** Enum for the possible user capacity filter */
export enum UserCapacityEnum {
  /** c0to50 */
  C0To50 = 'C0TO50',
  /** c50to75 */
  C50To75 = 'C50TO75',
  /** c75to100 */
  C75To100 = 'C75TO100',
  /** over100 */
  Over100 = 'OVER100'
}

/** Enum for possible saved filter types */
export enum UserFilterViewEnumType {
  /** project */
  Project = 'PROJECT',
  /** task */
  Task = 'TASK'
}

/** Enum for the possible user project organization types */
export enum UserProjectOrganizationTypeEnumType {
  /** Provider projects that have been archived */
  Archived = 'ARCHIVED',
  Customer = 'CUSTOMER',
  /** Provider projects that have been deleted */
  Deleted = 'DELETED',
  Provider = 'PROVIDER',
  /** Provider projects including those that were archived */
  ResourceManagement = 'RESOURCE_MANAGEMENT',
  ThirdParty = 'THIRD_PARTY'
}

/** Enum for the possible user roles */
export enum UserRoleEnumType {
  /** admin */
  Admin = 'ADMIN',
  /** contributor */
  Contributor = 'CONTRIBUTOR',
  /** guide */
  Guide = 'GUIDE',
  /** manager */
  Manager = 'MANAGER',
  /** observer */
  Observer = 'OBSERVER',
  /** project_manager */
  ProjectManager = 'PROJECT_MANAGER',
  /** super_admin */
  SuperAdmin = 'SUPER_ADMIN',
  /** task_owner */
  TaskOwner = 'TASK_OWNER'
}

/** Enum for the possible actions */
export enum SignOffActionEnumType {
  /** approve */
  Approve = 'APPROVE',
  /** reject */
  Reject = 'REJECT'
}
